<script lang="typescript">
  export let type = "info";
  export let reverse = false;
</script>

<div class:reverse class="panel {type}">
  <slot></slot>
</div>

<style>
  .panel {
    border: 1px solid #eee;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 36px;
    background-color: #eee;
    color: #333;
  }

  .panel.reverse {
    color: #333;
  }

  .panel.error {
    border-color: red;
  }
</style>

